import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { $themeConfig } from '../theme.config';
import { StorageService } from './storage.service';
import { IStoreData } from './interface/store-data.interface';

@Injectable({ providedIn: 'root' })
export class ThemeService {
    constructor(
        private store: Store<{ index: IStoreData }>,
        private storage: StorageService,
    ) {}

    initTheme() {
        let theme = this.storage.get('theme') || $themeConfig.theme;
        this.store.dispatch({ type: 'toggleTheme', payload: theme });

        let menu = this.storage.get('menu') || $themeConfig.menu;
        this.store.dispatch({ type: 'toggleMenu', payload: menu });

        let layout = this.storage.get('layout') || $themeConfig.layout;
        this.store.dispatch({ type: 'toggleLayout', payload: layout });

        let rtl = this.storage.get('rtlClass') || $themeConfig.rtlClass;
        this.store.dispatch({ type: 'toggleRTL', payload: rtl });

        let animation = this.storage.get('animation') || $themeConfig.animation;
        this.store.dispatch({ type: 'toggleAnimation', payload: animation });

        let navbar = this.storage.get('navbar') || $themeConfig.navbar;
        this.store.dispatch({ type: 'toggleNavbar', payload: navbar });

        let semidark = this.storage.get('semidark');
        const semi = semidark === 'true' ? true : $themeConfig.semidark;
        this.store.dispatch({ type: 'toggleSemidark', payload: semi });
    }
}
